export { default } from "./MailingListPage";



// WEBPACK FOOTER //
// ./src/screens/MailingList/index.ts